<div class="asc-report" [class.asc-list-mode]="activeTab === 'asc-list'" [class.asc-tsinfo-mode]="activeTab === 'timesheet-info'">

  <!-- タブナビゲーション -->
  <div class="tab-navigation">
    <div class="tabs">
      <button *ngFor="let tab of tabs" [class]="'tab-button ' + (activeTab === tab.id ? 'active' : '')"
        (click)="switchTab(tab.id)">
        {{ tab.name }}
      </button>
    </div>
  </div>

  <!-- タブコンテンツ -->
  <div class="tab-content">

    <!-- ASC一覧出力タブ -->
    <div [style.display]="activeTab === 'asc-list' ? 'flex' : 'none'" class="tab-panel">
      <div class="asc-list-section">

        <!-- 条件設定エリア -->
        <div class="condition-with-buttons">
          <div class="condition-area">
          <!-- 1行目:抽出条件 -->
          <div class="condition-row">
            <div class="condition-group">
              <label for="yearMonth">年月度:</label>
              <select id="yearMonth" [(ngModel)]="formData.yearMonth" class="form-select">
                <option value="">選択してください</option>
                <option *ngFor="let option of yearMonthOptions" [value]="option.value">{{ option.label }}</option>
              </select>
            </div>

            <div class="condition-group">
              <label>締日:</label>
              <div class="radio-group">
                <label class="radio-label">
                  <input type="radio" name="closeDate" value="15" [(ngModel)]="formData.closeDate">
                  <span>15日</span>
                </label>
                <label class="radio-label">
                  <input type="radio" name="closeDate" value="0" [(ngModel)]="formData.closeDate">
                  <span>末日</span>
                </label>
                <label class="radio-label">
                  <input type="radio" name="closeDate" value="" [(ngModel)]="formData.closeDate">
                  <span>すべて</span>
                </label>
              </div>
            </div>

            <div class="condition-group">
              <label for="customerCode">顧客番号 (先頭8文字):</label>
              <input 
                type="text" 
                id="customerCode" 
                [(ngModel)]="formData.customerCode" 
                class="form-input customer-code-input"
                placeholder="XXX-XXXX"
                maxlength="8"
                autocomplete="off"
                (input)="formatCustomerCode($event)"
                (keypress)="validateCustomerCodeInput($event)">
            </div>
          </div>

          <!-- 2行目: 支店番号 -->
          <div class="condition-row">
            <div class="condition-group">
              <label for="branchNumbers">支店番号:</label>
              <!-- LOAD TEST: value="032" pre-filled. Remove value attr after load test. -->
              <input type="text" id="branchNumbers" [(ngModel)]="formData.branchNumbers" class="form-input"
                placeholder="例: 023,135" autocomplete="off">
            </div>
            <div class="condition-group">
              <button type="button" class="btn" (click)="loadCustomerList()" [disabled]="!formData.yearMonth || isLoadingCustomerList">
                <span *ngIf="isLoadingCustomerList">取得中...</span>
                <span *ngIf="!isLoadingCustomerList">顧客一覧作成 ＞</span>
              </button>
              <select *ngIf="customerList.length > 0" id="customerSelect" [(ngModel)]="selectedCustomerId" (change)="onCustomerSelect()" class="form-selectbig">
                <option value="">— 選択してください —</option>
                <option *ngFor="let customer of customerList" [value]="customer.customerID">{{ customer.customerName }}</option>
              </select>
            </div>
          </div>

          <!-- 3行目: 説明エリア -->
          <div class="condition-row">
              <small class="form-note">※支店番号入力なしは全支店対象、複数支店の指定はカンマで列記</small>
          </div>

          <!-- 4行目: AND条件・表示項目・出力項目 -->
          <div class="condition-row">
            <div class="condition-group">
              <label for="andCondition">AND条件:</label>
              <select id="andCondition" [(ngModel)]="andCondition" (change)="onAndConditionChange()"
                class="form-select w160">
                <option value="none">なし</option>
                <option value="overtime">残業日あり</option>
                <option value="holiday">休日勤務あり</option>
                <option value="absence">欠勤日あり</option>
                <option value="paidHoliday">有給休暇取得あり</option>
                <option value="teleWork">在宅勤務あり</option>
                <option value="unreported">未報告/否認あり</option>
                <option value="unapproved">未承認あり</option>
                <option value="comments">コメントあり</option>
              </select>
            </div>

            <div class="condition-group">
              <label>表示項目:</label>
              <div class="radio-group">
                <label class="radio-label">
                  <input type="radio" name="displayOption" value="allItems" [(ngModel)]="displayOption"
                    [disabled]="andCondition === 'unreported' || andCondition === 'unapproved' || andCondition === 'comments'">
                  <span>全項目</span>
                </label>
                <label class="radio-label">
                  <input type="radio" name="displayOption" value="conditionItems" [(ngModel)]="displayOption"
                    [disabled]="andCondition === 'none'">
                  <span>条件項目のみ</span>
                </label>
              </div>
            </div>

            <div class="condition-group">
              <label>出力項目:</label>
              <div class="radio-group">
                <label class="radio-label">
                  <input type="radio" name="outputOption" value="summary" [(ngModel)]="outputOption">
                  <span>サマリー</span>
                </label>
                <label class="radio-label">
                  <input type="radio" name="outputOption" value="detail" [(ngModel)]="outputOption"
                    [disabled]="andCondition !== 'absence' && andCondition !== 'paidHoliday' && andCondition !== 'teleWork'">
                  <span>詳細</span>
                </label>
              </div>
            </div>
          </div>

          </div>
          <!-- ボタンエリア -->
          <div class="button-row">
            <button type="button" class="btn btn-primary" (click)="viewReport()" [disabled]="isLoading">
              <span *ngIf="isLoading">読み込み中...</span>
              <span *ngIf="!isLoading">表示</span>
            </button>
            <button type="button" class="btn btn-success" (click)="exportCsv()"
              [disabled]="isLoading || !formData.yearMonth || (!formData.customerCode.trim() && !formData.branchNumbers.trim())">CSV出力</button>
            <button type="button" class="btn btn-secondary" (click)="resetForm()">クリア</button>
            <button type="button" class="btn btn-warning" (click)="sendReminder()" *ngIf="showRemindButton && readWrite && adminLevel >= 3"
              [disabled]="selectedItems.size === 0 || !isValidReminderPeriod()"
              [title]="!isValidReminderPeriod() ? '過去分へのリマインド送信はできません' : ''">
              リマインド送信
              <span *ngIf="selectedItems.size > 0 && isValidReminderPeriod()">({{ selectedItems.size }}件)</span>
              <span *ngIf="!isValidReminderPeriod()" class="period-warning"> - 期間外</span>
            </button>
          </div>
        </div>

        <!-- プログレスバー表示 -->
        <div class="progress-container" *ngIf="showProgressBar">
          <div class="progress-wrapper">
            <div class="progress-info">
              <span class="progress-text">CSV生成中... {{progressValue}}%</span>
              <button type="button" class="btn btn-sm btn-secondary" (click)="cancelCsvExport()">
                キャンセル
              </button>
            </div>
            <div class="progress-bar">
              <div class="progress-bar-fill" [style.width.%]="progressValue"></div>
            </div>
          </div>
        </div>

        <!-- エラーメッセージ -->
        <div class="error-message" *ngIf="errorMessage" style="background-color: #f8d7da; color: #721c24; border: 1px solid #f5c6cb; padding: 10px; margin: 10px 0; border-radius: 4px;">
          {{ errorMessage }}
        </div>

        <!-- 成功メッセージ -->
        <div class="success-message" *ngIf="successMessage" style="background-color: #d4edda; color: #155724; border: 1px solid #c3e6cb; padding: 10px; margin: 10px 0; border-radius: 4px;">
          {{ successMessage }}
        </div>

        <!-- 抽出結果・ページネーション -->
        <div class="pagination-area" *ngIf="reportData.length > 0">
          <div class="result-info">
            <div class="result-summary">
              <span class="result-label">抽出結果:</span>
              <span class="total-count">全{{ totalRecords.toLocaleString() }}件</span>
              <span class="condition-text" *ngIf="getConditionSummary()">( {{ getConditionSummary() }} )</span>
            </div>
            <div class="display-range">{{ getDisplayRange() }}</div>
            <div class="page-size-control">
              <label for="pageSize">表示件数:</label>
              <select id="pageSize" [value]="pageSize" (change)="changePageSize(+$any($event.target).value)" class="form-select">
                <option value="20">20件</option>
                <option value="50">50件</option>
                <option value="100">100件</option>
                <option value="200">200件</option>
                        </select>
            </div>
          </div>
          <div class="pagination" *ngIf="totalPages > 1">
            <button type="button" class="page-btn" [disabled]="currentPage === 1" (click)="goToFirstPage()">«</button>
            <button type="button" class="page-btn" [disabled]="currentPage === 1" (click)="goToPreviousPage()">‹</button>
            <button type="button" *ngFor="let pageNum of pageNumbers" class="page-btn"
              [class.active]="pageNum === currentPage" (click)="goToPage(pageNum)">
              {{ pageNum }}
            </button>
            <button type="button" class="page-btn" [disabled]="currentPage === totalPages" (click)="goToNextPage()">›</button>
            <button type="button" class="page-btn" [disabled]="currentPage === totalPages" (click)="goToLastPage()">»</button>
          </div>
          <div class="page-info" *ngIf="totalPages > 1">ページ {{ currentPage }} / {{ totalPages }}</div>
        </div>

        <!-- データテーブル -->
        <div class="table-container" *ngIf="reportData.length > 0">
          <table class="data-table">
            <thead>
              <!-- サマリーモード(allItems): 2段ヘッダー -->
              <ng-container *ngIf="appliedDisplayOption === 'allItems' && appliedOutputOption !== 'detail'">
                <tr>
                  <th colspan="4" class="center group-header">スタッフ情報</th>
                  <th colspan="4" class="center group-header">個別タブリンク</th>
                  <th colspan="5" class="center group-header">稼働時間合計</th>
                  <th colspan="4" class="center group-header">報告状況</th>
                  <th colspan="3" class="center group-header">勤務日数</th>
                  <th colspan="3" class="center group-header">勤務状況</th>
                </tr>
                <tr>
                  <th class="left name-col">顧客名</th>
                  <th class="left name-col">部署名</th>
                  <th class="center">スタッフ番号</th>
                  <th class="left">スタッフ氏名</th>
                  <th class="center">TS</th>
                  <th class="center">獲注</th>
                  <th class="center">ASC</th>
                  <th class="center">顧客</th>
                  <th class="right">時間内</th>
                  <th class="right">時間外</th>
                  <th class="right">深夜内</th>
                  <th class="right">深夜外</th>
                  <th class="right">合計</th>
                  <th class="right">未報告</th>
                  <th class="right">報告済</th>
                  <th class="right">否認</th>
                  <th class="right">承認済</th>
                  <th class="right">出勤</th>
                  <th class="right">欠勤</th>
                  <th class="right">有休</th>
                  <th class="right">在宅</th>
                  <th class="right">残業有</th>
                  <th class="right">休日勤務</th>
                </tr>
              </ng-container>
              <!-- 通常モード: 1段ヘッダー -->
              <tr *ngIf="appliedDisplayOption !== 'allItems' || appliedOutputOption === 'detail'">
                <th *ngIf="displayColumns.includes('checkbox')" class="center checkbox-col">
                  <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAllChange()">
                </th>
                <th *ngIf="displayColumns.includes('customerName')" class="left">顧客名</th>
                <th *ngIf="displayColumns.includes('jobOrderId')" class="right">獲注ID</th>
                <th *ngIf="displayColumns.includes('timesheetId')" class="right">ﾀｲﾑｼｰﾄID</th>
                <th *ngIf="displayColumns.includes('customerOfficeId')" class="right">顧客部署ID</th>
                <th *ngIf="displayColumns.includes('customerOfficeName')" class="left">顧客部署名</th>
                <th *ngIf="displayColumns.includes('branchId')" class="center">支店</th>
                <th *ngIf="displayColumns.includes('ascUq')" class="center">ASC UQ</th>
                <th *ngIf="displayColumns.includes('staffCode')" class="center">スタッフ番号</th>
                <th *ngIf="displayColumns.includes('staffName')" class="left">スタッフ氏名</th>
                <th *ngIf="displayColumns.includes('jobOrderLink')" class="center">獲注</th>
                <th *ngIf="displayColumns.includes('timesheetLink')" class="center">TS</th>
                <th *ngIf="displayColumns.includes('customerLink')" class="center">顧客</th>
                <th *ngIf="displayColumns.includes('ascLink')" class="center">ASC</th>
                <th *ngIf="displayColumns.includes('workTime')" class="right">時間内</th>
                <th *ngIf="displayColumns.includes('overWorkTime')" class="right">時間外</th>
                <th *ngIf="displayColumns.includes('midnightInWorkTime')" class="right">深夜内</th>
                <th *ngIf="displayColumns.includes('midnightOverWorkTime')" class="right">深夜外</th>
                <th *ngIf="displayColumns.includes('total')" class="right">合計</th>
                <th *ngIf="displayColumns.includes('overtimeDays')" class="right">残業日</th>
                <th *ngIf="displayColumns.includes('holidayWork')" class="right">休日勤務</th>
                <th *ngIf="displayColumns.includes('absence')" class="right">欠勤</th>
                <th *ngIf="displayColumns.includes('paidHoliday')" class="right">有休</th>
                <th *ngIf="displayColumns.includes('teleWork')" class="right">在宅</th>
                <th *ngIf="displayColumns.includes('editing')" class="right">未報告</th>
                <th *ngIf="displayColumns.includes('submitted')" class="right">報告済</th>
                <th *ngIf="displayColumns.includes('denied')" class="right">否認</th>
                <th *ngIf="displayColumns.includes('approved')" class="right">承認済</th>
                <th *ngIf="displayColumns.includes('ascRemind')" class="center">最終リマインド日時</th>
                <th *ngIf="displayColumns.includes('cusRemind')" class="center">最終リマインド日時</th>
                <th *ngIf="displayColumns.includes('comments')" class="left comment-col">コメント</th>
                <th *ngIf="displayColumns.includes('dayDate')" class="center">対象日</th>
              </tr>
            </thead>
            <tbody>
              <!-- サマリーモード(allItems): 固定列 -->
              <ng-container *ngIf="appliedDisplayOption === 'allItems' && appliedOutputOption !== 'detail'">
                <tr *ngFor="let row of reportData">
                  <td class="left name-col">{{ row.customerName }}</td>
                  <td class="left name-col">{{ row.customerOfficeName }}</td>
                  <td class="center">{{ row.staffCode }}</td>
                  <td class="left"><a *ngIf="row.ascUq && adminLevel >= 3 && readWrite" (click)="navigateToApprovalReturn(row.timesheetId, row.ascUq)" class="link-text">{{ row.staffName }}</a><span *ngIf="!row.ascUq || adminLevel < 3 || !readWrite">{{ row.staffName }}</span></td>
                  <td class="center"><a (click)="navigateToTsInfo({ timesheetId: +row.timesheetId, yearMonth: formData.yearMonth, userCode: row.staffCode })" class="link-text">■</a></td>
                  <td class="center"><a (click)="navigateToJobOrderInfo(+row.jobOrderId)" class="link-text">■</a></td>
                  <td class="center">
                    <a *ngIf="row.ascUq" (click)="navigateToAscInfo({ ascUq: row.ascUq.toString() })" class="link-text">■</a>
                  </td>
                  <td class="center">
                    <a *ngIf="row.customerOfficeId" (click)="navigateToCustomerInfo(+row.customerOfficeId)" class="link-text">■</a>
                  </td>
                  <td class="right">{{ toHHMM(row.workTime) }}</td>
                  <td class="right">{{ toHHMM(row.overWorkTime) }}</td>
                  <td class="right">{{ toHHMM(row.midnightInWorkTime) }}</td>
                  <td class="right">{{ toHHMM(row.midnightOverWorkTime) }}</td>
                  <td class="right">{{ toHHMM(row.total) }}</td>
                  <td class="right">{{ row.editing || 0 }}</td>
                  <td class="right">{{ row.submitted || 0 }}</td>
                  <td class="right">{{ row.denied || 0 }}</td>
                  <td class="right">{{ row.approved || 0 }}</td>
                  <td class="right">{{ row.attendanceDays || 0 }}</td>
                  <td class="right">{{ row.absence || 0 }}</td>
                  <td class="right">{{ row.paidHoliday || 0 }}</td>
                  <td class="right">{{ row.teleWork || 0 }}</td>
                  <td class="right">{{ row.overtimeDays || 0 }}</td>
                  <td class="right">{{ row.holidayWork || 0 }}</td>
                </tr>
              </ng-container>
              <!-- 通常モード: 条件付き列 -->
              <ng-container *ngIf="appliedDisplayOption !== 'allItems' || appliedOutputOption === 'detail'">
              <tr *ngFor="let row of reportData">
                <td *ngIf="displayColumns.includes('checkbox')" class="center">
                  <input type="checkbox" [checked]="isItemSelected(row.timesheetId)"
                    (change)="onItemSelectionChange(row.timesheetId, $any($event.target).checked)">
                </td>
                <td *ngIf="displayColumns.includes('customerName')" class="left name-col">{{ row.customerName }}</td>
                <td *ngIf="displayColumns.includes('jobOrderId')" class="right">
                  <a (click)="navigateToJobOrderInfo(+row.jobOrderId)" class="link-text">{{ row.jobOrderId }}</a>
                </td>
                <td *ngIf="displayColumns.includes('timesheetId')" class="right">
                  <a (click)="navigateToTsInfo({ timesheetId: +row.timesheetId, yearMonth: formData.yearMonth, userCode: row.staffCode })" class="link-text">{{ row.timesheetId }}</a>
                </td>
                <td *ngIf="displayColumns.includes('customerOfficeId')" class="right">
                  <a *ngIf="row.customerOfficeId" (click)="navigateToCustomerInfo(+row.customerOfficeId)" class="link-text">{{ row.customerOfficeId }}</a>
                  <span *ngIf="!row.customerOfficeId">{{ row.customerOfficeId }}</span>
                </td>
                <td *ngIf="displayColumns.includes('customerOfficeName')" class="left">{{ row.customerOfficeName }}</td>
                <td *ngIf="displayColumns.includes('branchId')" class="center">{{ (row.branchNumber + '').padStart(2, '0') }}</td>
                <td *ngIf="displayColumns.includes('ascUq')" class="center">
                  <a *ngIf="row.ascUq" (click)="navigateToAscInfo({ ascUq: row.ascUq.toString() })" class="link-text">{{ row.ascUq }}</a>
                  <span *ngIf="!row.ascUq">{{ row.ascUq }}</span>
                </td>
                <td *ngIf="displayColumns.includes('staffCode')" class="center">{{ row.staffCode }}</td>
                <td *ngIf="displayColumns.includes('staffName')" class="left"><a *ngIf="row.ascUq && adminLevel >= 3 && readWrite" (click)="navigateToApprovalReturn(row.timesheetId, row.ascUq)" class="link-text">{{ row.staffName }}</a><span *ngIf="!row.ascUq || adminLevel < 3 || !readWrite">{{ row.staffName }}</span></td>
                <td *ngIf="displayColumns.includes('jobOrderLink')" class="center">
                  <a (click)="navigateToJobOrderInfo(+row.jobOrderId)" class="link-text">■</a>
                </td>
                <td *ngIf="displayColumns.includes('timesheetLink')" class="center">
                  <a (click)="navigateToTsInfo({ timesheetId: +row.timesheetId, yearMonth: formData.yearMonth, userCode: row.staffCode })" class="link-text">■</a>
                </td>
                <td *ngIf="displayColumns.includes('customerLink')" class="center">
                  <a *ngIf="row.customerOfficeId" (click)="navigateToCustomerInfo(+row.customerOfficeId)" class="link-text">■</a>
                </td>
                <td *ngIf="displayColumns.includes('ascLink')" class="center">
                  <a *ngIf="row.ascUq" (click)="navigateToAscInfo({ ascUq: row.ascUq.toString() })" class="link-text">■</a>
                </td>
                <td *ngIf="displayColumns.includes('workTime')" class="right">{{ toHHMM(row.workTime) }}</td>
                <td *ngIf="displayColumns.includes('overWorkTime')" class="right">{{ toHHMM(row.overWorkTime) }}</td>
                <td *ngIf="displayColumns.includes('midnightInWorkTime')" class="right">{{ toHHMM(row.midnightInWorkTime) }}</td>
                <td *ngIf="displayColumns.includes('midnightOverWorkTime')" class="right">{{ toHHMM(row.midnightOverWorkTime) }}</td>
                <td *ngIf="displayColumns.includes('total')" class="right">{{ toHHMM(row.total) }}</td>
                <td *ngIf="displayColumns.includes('overtimeDays')" class="right">{{ row.overtimeDays || 0 }}</td>
                <td *ngIf="displayColumns.includes('holidayWork')" class="right">{{ row.holidayWork || 0 }}</td>
                <td *ngIf="displayColumns.includes('absence')" class="right">{{ row.absence || 0 }}</td>
                <td *ngIf="displayColumns.includes('paidHoliday')" class="right">{{ row.paidHoliday || 0 }}</td>
                <td *ngIf="displayColumns.includes('teleWork')" class="right">{{ row.teleWork || 0 }}</td>
                <td *ngIf="displayColumns.includes('editing')" class="right">{{ row.editing || 0 }}</td>
                <td *ngIf="displayColumns.includes('submitted')" class="right">{{ row.submitted || 0 }}</td>
                <td *ngIf="displayColumns.includes('denied')" class="right">{{ row.denied || 0 }}</td>
                <td *ngIf="displayColumns.includes('approved')" class="right">{{ row.approved || 0 }}</td>
                <td *ngIf="displayColumns.includes('ascRemind')" class="center">{{ row.ascRemind ? (row.ascRemind | date:'yyyy/MM/dd HH:mm') : '' }}</td>
                <td *ngIf="displayColumns.includes('cusRemind')" class="center">{{ row.cusRemind ? (row.cusRemind | date:'yyyy/MM/dd HH:mm') : '' }}</td>
                <td *ngIf="displayColumns.includes('comments')" class="left comment-col">{{ row.comments || '' }}</td>
                <td *ngIf="displayColumns.includes('dayDate')" class="center">{{ row.dayDate ? (row.dayDate | date:'yyyy/MM/dd') : '' }}</td>
              </tr>
              </ng-container>
            </tbody>
          </table>
        </div>

        <!-- データがない場合のメッセージ -->
        <div class="no-data-message" *ngIf="!isLoading && reportData.length === 0 && !errorMessage">
          <p>表示ボタンをクリックしてデータを取得してください。</p>
        </div>

        <!-- ローディング表示 -->
        <div class="loading-message" *ngIf="isLoading">
          <p>データを取得しています...</p>
        </div>

      </div>
    </div>

    <!-- その他のタブ(今後実装) -->
    <div [style.display]="activeTab === 'timesheet-info' ? 'block' : 'none'" class="tab-panel">
      <app-asc-tsinfo 
        (navigateToJobOrder)="navigateToJobOrderInfo($event)"
        (navigateToAsc)="navigateToAscInfo($event)"
        (navigateToCustomer)="navigateToCustomerInfo($event)"
        (proxyRequested)="onProxyRequested($event)">
      </app-asc-tsinfo>
    </div>

    <div [style.display]="activeTab === 'job-order-info' ? 'block' : 'none'" class="tab-panel">
      <app-asc-jobinfo
        (navigateToAsc)="navigateToAscInfo($event)"
        (navigateToCustomer)="navigateToCustomerInfo($event)"
        (navigateToTs)="navigateToTsInfo($event)">
      </app-asc-jobinfo>
    </div>

    <div [style.display]="activeTab === 'asc-info' ? 'block' : 'none'" class="tab-panel">
      <app-asc-info
        (navigateToJobOrder)="navigateToJobOrderInfo($event)"
        (navigateToTs)="navigateToTsInfo($event)"
        (navigateToCustomer)="navigateToCustomerInfo($event)">
      </app-asc-info>
    </div>

    <div [style.display]="activeTab === 'customer-info' ? 'block' : 'none'" class="tab-panel">
      <app-asc-customer
        (navigateToJobOrder)="navigateToJobOrderInfo($event)"
        (navigateToAsc)="navigateToAscInfo($event)">
      </app-asc-customer>
    </div>

    <!-- 代理処理タブ -->
    <div [style.display]="activeTab === 'proxy' ? 'block' : 'none'" class="tab-panel">
      <!-- TS情報タブから減方された場合のメッセージ -->
      <div *ngIf="!proxyOperation" class="proxy-placeholder">
        <p>TS情報タブでタイムシートを選択し、「承認差戻」「代理申請」「代理承認」ボタンを押して処理を進めてください。</p>
      </div>
      <!-- 承認差戻 -->
      <app-repesentative-timesheet
        *ngIf="proxyOperation === 'return'"
        [inputId]="proxyEncryptedId"
        [inputUserId]="proxyEncryptedUserId"
        [embeddedMode]="true"
        (navigateToResource)="onRepViewToResource()"
        (navigateToApprover)="onRepViewToApprover()">
      </app-repesentative-timesheet>
      <!-- 代理申請 -->
      <!--
      <app-rep-resource-timesheet
        *ngIf="proxyOperation === 'submit'"
        [inputId]="proxyEncryptedId"
        [inputUserId]="proxyEncryptedUserId"
        [embeddedMode]="true"
        (backClicked)="onRepResourceBack()">
      -->
      <app-rep-resource-timesheet
        *ngIf="proxyOperation === 'submit'"
        [inputId]="proxyEncryptedId"
        [inputUserId]="proxyEncryptedUserId"
        [embeddedMode]="true"
        (backClicked)="onRepResourceBack()"
        (logClicked)="onRepResourceLog()">
      </app-rep-resource-timesheet>
      <!-- 代理申請Backボタンで戻った際のrepresentative-timesheet表示 -->
      <app-repesentative-timesheet
        *ngIf="proxyOperation === 'rep-view'"
        [inputId]="proxyEncryptedId"
        [inputUserId]="proxyEncryptedUserId"
        [embeddedMode]="true"
        (navigateToResource)="onRepViewToResource()"
        (navigateToApprover)="onRepViewToApprover()">
      </app-repesentative-timesheet>
      <!-- 代理承認 -->
      <!--
      <app-rep-approver-timesheet
        *ngIf="proxyOperation === 'approve'"
        [inputId]="proxyEncryptedId"
        [inputUserId]="proxyEncryptedUserId"
        [embeddedMode]="true"
        (backClicked)="onRepApproverBack()">
      </app-rep-approver-timesheet>
      -->
      <app-rep-approver-timesheet
        *ngIf="proxyOperation === 'approve'"
        [inputId]="proxyEncryptedId"
        [inputUserId]="proxyEncryptedUserId"
        [embeddedMode]="true"
        (backClicked)="onRepApproverBack()"
        (logClicked)="onRepApproverLog()">
      </app-rep-approver-timesheet>
      <app-associate-time-log
        *ngIf="proxyOperation === 'submit-log'"
        [inputId]="proxyEncryptedId"
        [inputUserId]="proxyEncryptedUserId"
        [embeddedMode]="true"
        [fromMode]="'resource'"
        (backClicked)="onRepResourceLogBack()">
      </app-associate-time-log>
      <app-associate-time-log
        *ngIf="proxyOperation === 'approve-log'"
        [inputId]="proxyEncryptedId"
        [inputUserId]="proxyEncryptedUserId"
        [embeddedMode]="true"
        [fromMode]="'approver'"
        (backClicked)="onRepApproverLogBack()">
      </app-associate-time-log>
    </div>

    <!-- アラート（勤務日）タブ -->
    <div *ngIf="activeTab === 'alert_period' && (adminLevel === 4 || adminLevel === 9)" class="tab-panel">
      <app-asc-alertperiod
        (navigateToJobOrder)="navigateToJobOrderInfo($event)"
        (navigateToAsc)="navigateToAscInfo($event)"
        (navigateToCustomer)="navigateToCustomerInfo($event)"
        (transferToProcessing)="onTransferToProcessing($event)">
      </app-asc-alertperiod>
    </div>

    <!-- 変更申請管理タブ -->
    <div [hidden]="activeTab !== 'alert_etc'" class="tab-panel">
      <app-asc-chgrequest
        (navigateToJobOrder)="navigateToJobOrderInfo($event)"
        (navigateToAsc)="navigateToAscInfo({ userCode: $event })"
        (navigateToCustomer)="navigateToCustomerInfo($event)"
        (navigateToTransferWithRequestId)="navigateToTransferWithRequestId($event)">
      </app-asc-chgrequest>
    </div>


    <!-- 転記処理タブ（特別なURLパラメータでのみ表示） -->
    <div [hidden]="activeTab !== 'move_ts'" class="tab-panel">
      <app-asc-transfer 
        [odchgId]="selectedOdchgId"
        [autoLoadRequestId]="autoLoadRequestId"
        (navigateToJobOrder)="navigateToJobOrderInfo($event)"
        (navigateToCustomer)="navigateToCustomerInfo($event)"
        (navigateToTs)="navigateToTsInfo($event)">
      </app-asc-transfer>
    </div>

  </div>

</div>